import React, { Component } from "react";
import { message, Table, Tag, Spin, Tooltip } from "antd";
import { ArrowLeftOutlined, EyeOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import axios from "axios";
import { ModalItem, ButtonItem } from "../../../../Components/Items";
import PuntoForm from "../ProcesoForm/PuntoForm";

/**
 * Modal que muestra una tabla de puntos guardados como plantilla;
 * al seleccionar uno se muestra el PuntoForm con sus datos (disabled)
 * para previsualizar antes de usarlo en el proceso.
 */
class ModalPlantillaPunto extends Component {
  plantillaFormRef = React.createRef();

  state = {
    loading: false,
    plantillas: [],      // lista de puntos de procesos plantilla
    puntoPrevio: null,   // punto seleccionado para previsualizar
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ puntoPrevio: null });
      this.consultarPlantillas();
    }
    if (!this.props.visible && prevProps.visible) {
      this.setState({ plantillas: [], loading: false, puntoPrevio: null });
    }
  }

  consultarPlantillas() {
    this.setState({ loading: true });
    axios
      .post(
        "punto/obtenerPlantillas",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const data = res.data.data;
          const lista = Array.isArray(data) ? data : [];
          this.setState({ plantillas: lista.map((p, i) => ({ ...p, _rowKey: p._id || `p_${i}` })) });
        } else {
          this.setState({ plantillas: [] });
        }
      })
      .catch(() => message.error("Error al cargar plantillas de puntos"))
      .finally(() => this.setState({ loading: false }));
  }

  seleccionarPlantilla(punto) {
    this.setState({ puntoPrevio: punto });
    
    setTimeout(() => {
      if (this.plantillaFormRef.current?.formRef?.current) {
        this.plantillaFormRef.current.formRef.current.setFieldsValue({
          nombre: punto.nombre || "",
          descripcion: punto.descripcion || "",
          observaciones: punto.observaciones || "",
          esPlantilla: punto.esPlantilla || false,
          version: punto.version || "",
          imagen: punto.imagen || [], 
          procedimiento: { pasos: punto.procedimiento?.pasos || [] },
          criterios: punto.criterios || [],
        });
      }
    }, 0);
  }

  normalizarPasos(pasos = []) {
    return pasos.map((paso) => ({
      descripcion: paso.descripcion,
    }));
  }

  usarPlantilla() {
    const { puntoPrevio } = this.state;
    if (!puntoPrevio) return;
    
    this.props.onSuccess({
      ...puntoPrevio, 
      nombre: puntoPrevio.nombre || "",
      descripcion: puntoPrevio.descripcion || "",
      observaciones: puntoPrevio.observaciones || "",
      derivadoDe: puntoPrevio._id,
      imagen: puntoPrevio.imagen || [], 
      procedimiento: { pasos: this.normalizarPasos(puntoPrevio.procedimiento?.pasos) },
      criterios: puntoPrevio.criterios || [],
    });
  }

  render() {
    const { visible, onCancel } = this.props;
    const { loading, plantillas, puntoPrevio } = this.state;

    const columnas = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        ellipsis: true,
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        ellipsis: true,
      },
      {
        title: "Pasos",
        key: "pasos",
        align: "center",
        width: 70,
        render: (_, r) => (
          <Tag color="blue">{r.procedimiento?.pasos?.length ?? 0}</Tag>
        ),
      },
      {
        title: "Criterios",
        key: "criterios",
        align: "center",
        width: 80,
        render: (_, r) => (
          <Tag color="cyan">{r.criterios?.length ?? 0}</Tag>
        ),
      },
      {
        title: "Acción",
        key: "ver",
        width: 90,
        render: (_, record) => (
          <Tooltip
            title ="Previsualizar"
          >
            <ButtonItem
            size="small"
            type="primary"
            lila
            onClick={() => this.seleccionarPlantilla(record)}
            icon={<EyeOutlined/>}
          />
          </Tooltip>
        ),
      },
    ];

    return (
      <ModalItem
        title="Seleccionar Plantilla de Punto"
        visible={visible}
        spinning={false}
        onCancel={onCancel}
        paddingTop
        width={980}
      >
        <div style={{ marginTop: 16 }}>
          {!puntoPrevio ? (
            
            <Spin spinning={loading}>
              {!loading && plantillas.length === 0 && (
                <p style={{ textAlign: "center", color: "#999", padding: "24px 0" }}>
                  No hay puntos de plantilla disponibles en la base de datos.
                </p>
              )}
              <Table
                dataSource={plantillas}
                columns={columnas}
                rowKey="_rowKey"
                size="small"
                pagination={{ pageSize: 8 }}
              />
            </Spin>
          ) : (
            
            <div>
              <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center' }}>
                <ButtonItem
                  icon={<ArrowLeftOutlined />}
                  size="small"
                  onClick={() => this.setState({ puntoPrevio: null })}
                >
                  Regresar a la lista
                </ButtonItem>
                <Tag color="purple" style={{ marginLeft: 16, fontSize: '14px', padding: '4px 8px' }}>
                  Previsualizando: {puntoPrevio.nombre}
                </Tag>
              </div>

              <PuntoForm ref={this.plantillaFormRef} disabled={true} initialValues={puntoPrevio} />

              <div style={{ textAlign: "right", marginTop: 24, marginBottom: 8 }}>
                <ButtonItem style={{ marginRight: 8 }} onClick={() => this.setState({ puntoPrevio: null })}>
                  Cancelar
                </ButtonItem>
                <ButtonItem type="primary" size="large" onClick={() => this.usarPlantilla()}>
                  Usar esta Plantilla
                </ButtonItem>
              </div>
            </div>
          )}
        </div>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalPlantillaPunto);